import {
	ceilSisDuration,
	ceilSisTime,
	floorSisDuration,
	floorSisTime,
	getSisDateAsISO,
	getSisDateTimeAsString,
	getSisDurationAsISO,
	getSisDurationAsNumber,
	getSisDurationBetween24H,
	getSisTimeAsISO,
	getSisTimeAsNumber,
	parseSisDate,
	parseSisDateTime,
	parseSisDuration,
	parseSisTime,
	roundSisDuration,
	roundSisTime,
} from 'util/SisDateTime'
import moment from 'moment'
import {isDebugEnabled, log} from 'common/log'
import {ClipboardMap} from 'module/Clipboard/type/ClipboardTypes'
import {CFModel} from 'module/CustomField/type/CFType'
import {applySisKeyFieldRuleset, objectifyStringPath, padStr, setFixedStringAt, stringifyObjectPath, stripHTML, substrTypeaware} from 'util/StringUtil'
import {blackOrWhite} from 'util/Color'
import {alertError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'
import {CFimmutable} from 'module/CustomField/util/CFimmutable'
import {CF} from 'module/CustomField/util/CustomField'
import _ from 'lodash'
import {CustomFieldTO} from 'generated/JavaTO'

/**
 *
 * @param transformString entweder JS-Einzeiler oder Funktionsinhalt, das mit dem return-Statement
 * @param value Wert des ersten genannten Clipboards
 * @param pos aktuelle pos des Clipboard-value
 * @param Clipboard Gesamtes aktuelles Clipboard
 * @param model Model auf dem gearbeitet wird
 * @param cfDef Aktuelles cfDef, das bearbeitet wird (z. B. cfDef mit dem paste-cfAttr)
 * @param cfDefs Alle cfDefs, die im Formular verwendet werden.
 */
export function transformCFData(
	transformString: string | undefined,
	value: string | number | null | undefined,
	pos: number | undefined,
	Clipboard: ClipboardMap,
	model: CFModel,
	cfDef: CustomFieldTO,
	cfDefs: CustomFieldTO[],
) {
	if (!transformString) return value
	model = _.cloneDeep(model)
	try {
		const ret = new Function(`{
value,
pos,
Clipboard,
model,
cfDef,
cfDefs,
/** libs */
_,
moment,
/** SisDateTime */
ceilSisDuration,
ceilSisTime,
floorSisDuration,
floorSisTime,
getSisDateAsISO,
getSisDateTimeAsString,
getSisDurationAsISO,
getSisDurationAsNumber,
getSisDurationBetween24H,
getSisTimeAsISO,
getSisTimeAsNumber,
parseSisDate,
parseSisDateTime,
parseSisDuration,
parseSisTime,
roundSisDuration,
roundSisTime,
/** StringUtil */
padStr,
setFixedStringAt,
substrTypeaware,
applySisKeyFieldRuleset,
stringifyObjectPath,
objectifyStringPath,
stripHTML,
/** ColorUtil */
blackOrWhite,
/** CF util  */
CF,
CFimmutable,
}`, (!/\breturn\b/.test(transformString) ? 'return ' : '') + transformString)({
			value,
			pos,
			Clipboard,
			model,
			cfDef,
			cfDefs,
			/** libs */
			_,
			moment,
			/** SisDateTime */
			ceilSisDuration,
			ceilSisTime,
			floorSisDuration,
			floorSisTime,
			getSisDateAsISO,
			getSisDateTimeAsString,
			getSisDurationAsISO,
			getSisDurationAsNumber,
			getSisDurationBetween24H,
			getSisTimeAsISO,
			getSisTimeAsNumber,
			parseSisDate,
			parseSisDateTime,
			parseSisDuration,
			parseSisTime,
			roundSisDuration,
			roundSisTime,
			/** StringUtil */
			padStr,
			setFixedStringAt,
			substrTypeaware,
			applySisKeyFieldRuleset,
			stringifyObjectPath,
			objectifyStringPath,
			stripHTML,
			/** ColorUtil */
			blackOrWhite,
			/** CF util  */
			CF,
			CFimmutable,
		})
		log.trace('transformCFData result', ret, value, pos, Clipboard, model, transformString)
		return ret
	} catch (e) {
		log.error('transformCFData Error in custom function: ', e, transformString, value, pos, Clipboard)
		void alertError('Syntaxfehler in der Parametrierung', e + '')
	}
}

if (isDebugEnabled()) window.sis = {...window.sis, transformCFData}